<template>
  <section class="section">
    <div class="container">
      <h1 class="title has-text-centered">
        Export des feuilles de temps
      </h1>

      <SelectEmployee
          @updateEmployee="updateEmployee">
      </SelectEmployee>

      <b-field grouped>
        <b-field label="Année">
          <b-select
              placeholder="Année"
              v-model="annee"
          >
            <option
                v-for="option in years"
                :value="option.value"
                :key="option.value">
              {{ option.years }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Mois">
          <b-select placeholder="Mois"
                    v-model="mois">
            <option
                v-for="option in month"
                :value="option.value"
                :key="option.value">
              {{ option.month }}
            </option>
          </b-select>
        </b-field>

        <!--
        <b-field label="Année complète">
          <b-checkbox
              v-model="fullYear"
              size="is-medium">
          </b-checkbox>
        </b-field>
        -->

      </b-field>

      <b-field label="Type d'export">
        <b-select
            placeholder="Sélectionner le type"
            v-model="format"
        >
          <option
              v-for="option in formats"
              :value="option.value"
              :key="option.value">
            {{ option.label }}
          </option>
        </b-select>
      </b-field>



      <b-button @click="asyncData">Exporter</b-button>





      <b-loading is-full-page v-model="isLoading" :can-cancel="false"></b-loading>

      {{ url }}

    </div>
  </section>
</template>

<script>

import SelectEmployee from "@/components/HELPERS/SelectEmployee";

export default {
  name: 'HomePage',
  components: {SelectEmployee},
  methods: {

    lastday: function(y,m) {
      return  new Date(y, (m-1) +1, 0).toLocaleDateString ("fr-CA");
    },

    // console.log(firstday(2020,5));
    firstday: function(y,m) {
      return  new Date(y, (m-1), 1).toLocaleDateString ("fr-CA");
    },

    updateEmployee: function(employee){
      this.employee = employee === null ? 0 : employee.id;
    },

    async asyncData() {
      // Check data integrity
      if (this.mois === null || this.employee === null) {
        this.$buefy.snackbar.open({
          duration: 4000,
          message: 'Veuillez sélectionner un mois / salarié',
          type: 'is-danger',
          position: 'is-bottom-left',
        })
        return
      }

      this.isLoading = true
      this.$axios.get(
          `exportfdt?` +
              `&dateStart=${this.firstday(this.annee, this.mois)}` +
              `&dateEnd=${this.lastday(this.annee, this.mois)}` +
              `&employee=${this.employee}` +
              `&format=${this.format}`
          , {responseType: 'blob'}).then(response => {
        this.isLoading = false
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `${this.firstday(this.annee, this.mois)}.zip`);
        document.body.appendChild(fileLink);
        fileLink.click();
      })
      .catch( err => {
        console.log(err)
        this.isLoading = false
        this.$buefy.snackbar.open({
          duration: 4000,
          message: 'Erreur lors de la récupération',
          type: 'is-danger',
          position: 'is-bottom-left',
        })
      })
    }
  },
  data() {
    return {
      dateStart: new Date(),
      dateEnd: new Date(),
      status: 0,
      employee: null,
      url: null,
      month: [
        {month: 'Janvier', value: 1},
        {month: 'Février', value: 2},
        {month: 'Mars', value: 3},
        {month: 'Avril', value: 4},
        {month: 'Mai', value: 5},
        {month: 'Juin', value: 6},
        {month: 'Juillet', value: 7},
        {month: 'Août', value: 8},
        {month: 'Septembre', value: 9},
        {month: 'Octobre', value: 10},
        {month: 'Novembre', value: 11},
        {month: 'Décembre', value: 12}
      ],
      years: [
        {years: '2019', value: 2019},
        {years: '2020', value: 2020},
        {years: '2021', value: 2021},
        {years: '2022', value: 2022},
        {years: '2023', value: 2023},
        {years: '2024', value: 2024},
        {years: '2025', value: 2025},
        {years: '2026', value: 2026},
      ],
      formats: [
        {value: 'dafc', label: 'Service DAFC'},
        {value: 'detail', label: 'Détail des lignes'},
        {value: 'life', label: 'Justificatif LIFE'},
      ],
      mois: null,
      annee: new Date().getFullYear(),
      format: 'dafc',
      fullYear: false,
      isLoading: false,

    }
  },
}
</script>
